import React from "react";
import { Modal } from "react-bootstrap";

import QuizMenu from "../Components/QuizMenu";
import "./QuizMenuModal.scss";

export default function QuizMenuModal(props) {
  const { showModal, handleModalToggle, questions, answeredList, handleBoxClick } = props;

  return (
    <Modal show={showModal} fullscreen={""} onHide={handleModalToggle} aria-labelledby="example-custom-modal-styling-title" className="quiz_menu_modal">
      <Modal.Header closeButton>
        <Modal.Title id="example-custom-modal-styling-title"></Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <QuizMenu questions={questions} answeredList={answeredList} handleBoxClick={handleBoxClick} handleModalToggle={handleModalToggle} />
      </Modal.Body>
    </Modal>
  );
}
